module.exports = __webpack_public_path__ + "static/img/11.5a01d0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/eng/11.png
// module id = Kxby
// module chunks = 0